import React from 'react';
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const ResultBadge = ({ completed }) => (
  <span className={`report-result-badge ${completed ? 'is-complete' : 'is-pending'}`}>
    {completed ? '완료' : '미완료'}
  </span>
);

const EmptyDetail = ({ children }) => <p className="report-detail-empty">{children}</p>;

const LearningDetails = ({ rows }) => {
  const homeworkRows = rows.filter((row) => row.homeworkAssigned === 'Y');
  const testRows = rows.filter((row) => row.testScoreCount > 0);
  const chartData = testRows.map((row) => ({
    date: row.lessonDate.slice(5).replace('-', '/'),
    score: row.testAverage,
  }));

  return (
    <section className="report-details">
      <article className="report-panel report-detail-card">
        <h2>진도 현황</h2>
        {!rows.length && <EmptyDetail>등록된 수업 진도가 없습니다.</EmptyDetail>}
        <ul>
          {rows.map((row) => (
            <li key={`progress-${row.lessonDate}`}>
              <div><strong>{row.lessonDate}</strong><span>{row.jindo || '진도 내용 없음'}</span></div>
              <ResultBadge completed={row.progressCheckedyn === 'Y'} />
            </li>
          ))}
        </ul>
      </article>

      <article className="report-panel report-detail-card">
        <h2>과제 현황</h2>
        {!homeworkRows.length && <EmptyDetail>등록된 과제가 없습니다.</EmptyDetail>}
        <ul>
          {homeworkRows.map((row) => (
            <li key={`homework-${row.lessonDate}`}>
              <div><strong>{row.lessonDate}</strong><span>{row.homework || '과제 내용 없음'}</span></div>
              <ResultBadge completed={row.homeworkCheckedyn === 'Y'} />
            </li>
          ))}
        </ul>
      </article>

      <article className="report-panel report-detail-card report-detail-card--test">
        <h2>TEST 결과 (OMR)</h2>
        {!testRows.length && <EmptyDetail>선택한 기간의 OMR 채점 결과가 없습니다.</EmptyDetail>}
        {!!testRows.length && (
          <>
            <div className="report-test-chart" aria-label="시험 점수 추이 그래프">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={chartData} margin={{ top: 10, right: 12, left: -24, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="date" tick={{ fontSize: 11 }} />
                  <YAxis domain={[0, 100]} tick={{ fontSize: 11 }} />
                  <Tooltip formatter={(value) => [`${value}점`, '평균']} />
                  <Line type="monotone" dataKey="score" stroke="#f97316" strokeWidth={3} dot={{ r: 4 }} />
                </LineChart>
              </ResponsiveContainer>
            </div>
            <ul>
              {testRows.map((row) => (
                <li key={`test-${row.lessonDate}`}>
                  <div><strong>{row.lessonDate}</strong><span>OMR {row.testScoreCount}건 채점</span></div>
                  <b className="report-test-score">{row.testAverage}점</b>
                </li>
              ))}
            </ul>
          </>
        )}
      </article>
    </section>
  );
};

export default LearningDetails;
